/** @format */
import { ChangeDetectionStrategy, Component, Inject, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FudisDialogService } from '@funidata/ngx-fudis';
import { CustomCourseUnitAttainment, CustomModuleAttainment, Workflow } from 'common-typescript/types';
import { EMPTY, Observable, take } from 'rxjs';
import { AuthService } from 'sis-common';
import { AppErrorHandler } from '../../error-handler/app-error-handler';
import { RECOMMENDATION_STATE, STUDENT_WORKFLOW_STATE } from '../../model/student-workflow-constants';
import { WorkflowEntityService } from '../../service/workflow-entity.service';

export function customAttainmentCreditInfoModalOpener(): (
    attainment: CustomCourseUnitAttainment | CustomModuleAttainment,
) => MatDialogRef<CustomAttainmentCreditInfoModalComponent, void> {
    const fudisDialogService = inject(FudisDialogService);
    return attainment =>
        fudisDialogService.open(CustomAttainmentCreditInfoModalComponent, {
            data: attainment,
        }) as MatDialogRef<CustomAttainmentCreditInfoModalComponent>;
}

@Component({
    selector: 'sis-custom-attainment-credit-info-modal',
    templateUrl: './custom-attainment-credit-info-modal.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CustomAttainmentCreditInfoModalComponent implements OnInit {
    currentTabIndex = 0;
    workflowObs$: Observable<Workflow>;
    readonly studentWorkflowState = STUDENT_WORKFLOW_STATE;
    readonly recommendationState = RECOMMENDATION_STATE;

    constructor(
        @Inject(MAT_DIALOG_DATA) public attainment: CustomCourseUnitAttainment | CustomModuleAttainment,
        public dialogRef: MatDialogRef<CustomAttainmentCreditInfoModalComponent, void>,
        private workflowEntityService: WorkflowEntityService,
        private appErrorHandler: AppErrorHandler,
        private authService: AuthService,
    ) {}

    ngOnInit(): void {
        if (this.isLoggedIn()) {
            this.workflowObs$ = this.attainment.workflowId
                ? this.workflowEntityService.getById(this.attainment.workflowId).pipe(take(1), this.appErrorHandler.defaultErrorHandler())
                : EMPTY;
        }
    }

    isLoggedIn(): boolean {
        return this.authService.loggedIn();
    }
}
